import { Injectable } from '@angular/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

@Injectable({
    providedIn: 'root'
})
export class SafeTranslateMessageFormatCompiler extends TranslateMessageFormatCompiler {
    /**
     * Intercepts and normalizes the language code (e.g., 'ca_ES' -> 'ca-ES')
     * to comply with BCP 47 standard format, ensuring @messageformat/core
     * can successfully resolve and compile ICU pluralization rules.
     */
    override compile(value: string, lang: string): any {
        const normalizedLang = lang ? lang.replace('_', '-') : lang;
        return super.compile(value, normalizedLang);
    }

    /**
     * Intercepts and normalizes the language code for batch compilation of translations.
     */
    override compileTranslations(translations: any, lang: string): any {
        const normalizedLang = lang ? lang.replace('_', '-') : lang;
        return super.compileTranslations(translations, normalizedLang);
    }
}
